module.exports = __webpack_public_path__ + "img/thumbnail_StripedSkunk_f_normal.e55cc40e.png";